import { __decorate } from 'tslib';
import { EventEmitter, NgZone, Output, Input, Component, NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { take } from 'rxjs/operators';
import { interval } from 'rxjs';
import { CommonModule } from '@angular/common';

var NgxDocViewerComponent = /** @class */ (function () {
    function NgxDocViewerComponent(domSanitizer, ngZone) {
        this.domSanitizer = domSanitizer;
        this.ngZone = ngZone;
        this.fullUrl = null;
        this.checkIFrameSubscription = null;
        this.configuredViewer = 'google';
        this.loaded = new EventEmitter();
        this.url = '';
        this.googleCheckInterval = 3000;
        this.disableContent = 'none';
        this.googleCheckContentLoaded = true;
    }
    Object.defineProperty(NgxDocViewerComponent.prototype, "viewer", {
        set: function (viewer) {
            var v = viewer.toLowerCase().trim();
            if (v !== 'google' && v !== 'office') {
                console.error("Unsupported viewer: '" + viewer + "'. Supported viewers: google, office");
            }
            this.configuredViewer = v;
        },
        enumerable: true,
        configurable: true
    });
    NgxDocViewerComponent.prototype.ngOnDestroy = function () {
        if (this.checkIFrameSubscription) {
            this.checkIFrameSubscription.unsubscribe();
        }
    };
    NgxDocViewerComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if ((changes.url && changes.url.currentValue !== changes.url.previousValue) ||
            changes.viewer && changes.viewer.currentValue !== changes.viewer.previousValue) {
            if (this.checkIFrameSubscription) {
                this.checkIFrameSubscription.unsubscribe();
            }
            if (!this.url) {
                this.fullUrl = null;
            }
            else {
                var u = this.url.indexOf('/') ? encodeURIComponent(this.url) : this.url;
                this.fullUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.configuredViewer === 'google' ?
                    "https://docs.google.com/gview?url=" + u + "&embedded=true" :
                    "https://view.officeapps.live.com/op/embed.aspx?src=" + u);
                // see:
                // https://stackoverflow.com/questions/40414039/google-docs-viewer-returning-204-responses-no-longer-working-alternatives
                // hack to reload iframe if it's not loaded.
                // would maybe be better to use view.officeapps.live.com but seems not to work with sas token.
                if (this.configuredViewer === 'google' && this.googleCheckContentLoaded) {
                    this.ngZone.runOutsideAngular(function () {
                        var iframe = document.querySelector('iframe');
                        _this.checkIFrame(iframe);
                        // if it's not loaded after the googleIntervalCheck, then open load again.
                        _this.checkIFrameSubscription = interval(_this.googleCheckInterval)
                            .pipe(take(Math.round(_this.googleCheckInterval === 0 ? 0 : 20000 / _this.googleCheckInterval)))
                            .subscribe(function () {
                            if (iframe == null) {
                                iframe = document.querySelector('iframe');
                                _this.checkIFrame(iframe);
                            }
                            _this.reloadIFrame(iframe);
                        });
                    });
                }
            }
        }
    };
    NgxDocViewerComponent.prototype.checkIFrame = function (iframe) {
        var _this = this;
        if (iframe) {
            iframe.onload = function () {
                _this.loaded.emit(null);
                if (_this.checkIFrameSubscription) {
                    _this.checkIFrameSubscription.unsubscribe();
                }
            };
        }
    };
    NgxDocViewerComponent.prototype.reloadIFrame = function (iframe) {
        if (iframe) {
            console.log('reloading..');
            iframe.src = iframe.src;
        }
    };
    NgxDocViewerComponent.ctorParameters = function () { return [
        { type: DomSanitizer },
        { type: NgZone }
    ]; };
    __decorate([
        Output()
    ], NgxDocViewerComponent.prototype, "loaded", void 0);
    __decorate([
        Input()
    ], NgxDocViewerComponent.prototype, "url", void 0);
    __decorate([
        Input()
    ], NgxDocViewerComponent.prototype, "googleCheckInterval", void 0);
    __decorate([
        Input()
    ], NgxDocViewerComponent.prototype, "disableContent", void 0);
    __decorate([
        Input()
    ], NgxDocViewerComponent.prototype, "googleCheckContentLoaded", void 0);
    __decorate([
        Input()
    ], NgxDocViewerComponent.prototype, "viewer", null);
    NgxDocViewerComponent = __decorate([
        Component({
            selector: 'ngx-doc-viewer',
            template: "\n        <iframe *ngIf=\"fullUrl && disableContent === 'none'\" id=\"iframe\" frameBorder=\"0\" [src]=\"fullUrl\"></iframe>\n        <div class=\"container\" *ngIf=\"disableContent !== 'none'\">\n            <div\n                [class.overlay-full]=\"disableContent === 'all'\"\n                [class.overlay-popout]=\"disableContent === 'popout' || disableContent === 'popout-hide'\"\n                [style.background-color]=\"disableContent === 'popout-hide' ? '#fff': 'transparent'\"\n            >\n            </div>\n            <iframe *ngIf=\"fullUrl\" id=\"iframe\"  frameBorder=\"0\" [src]=\"fullUrl\"></iframe>\n        </div>\n    ",
            styles: [":host {\n        display: block;\n    }\n    .container {\n        width: 100%;\n        height: 100%;\n        position: relative;\n    }\n    .overlay-popout {\n        width: 40px;\n        height: 40px;\n        right: 26px;\n        top: 11.5px;\n        position: absolute;\n        z-index: 1000;\n    }\n    .overlay-full {\n        width: 100%;\n        height: 100%;\n        right: 0;\n        top: 0;\n        position: absolute;\n        z-index: 1000;\n    }\n    iframe {\n        width: 100%;\n        height: 100%;\n    }\n    "]
        })
    ], NgxDocViewerComponent);
    return NgxDocViewerComponent;
}());

var NgxDocViewerModule = /** @class */ (function () {
    function NgxDocViewerModule() {
    }
    NgxDocViewerModule = __decorate([
        NgModule({
            imports: [CommonModule],
            declarations: [NgxDocViewerComponent],
            exports: [NgxDocViewerComponent]
        })
    ], NgxDocViewerModule);
    return NgxDocViewerModule;
}());

/**
 * Generated bundle index. Do not edit.
 */

export { NgxDocViewerComponent, NgxDocViewerModule };
//# sourceMappingURL=ngx-doc-viewer.js.map
